
<div class="modal-body">
  <p *ngIf="datas.message != null && datas.message != ''">
    {{ datas.message }}
  </p>
</div>
<div class="modal-footer">
  <button class="btn float-left" type="button" (click)="cancel()">
    <i class="fa fa-times"></i>
    {{ 'modal.cancelButton' | translate }}
  </button>
  <button class="btn btn-primary" type="button" (click)="validate()">
    <i class="fa fa-check"></i>
    {{ 'modal.validateButton' | translate }}
  </button>
</div>